import {call, put, select} from 'redux-saga/effects';
import {deletePubBeer} from 'services/pubs';
import {handleError} from 'store/app/error/saga';

import {getPubBeersACS, deletePubBeerACS} from '../requestAC';
import {IState} from '../slice';

export function* removePubBeer(action: ReturnType<typeof deletePubBeerACS>) {
  const pubBeerFilters: IState['pubBeerFilters'] = yield select((state) => state.beersManager.pubBeerFilters);

  try {
    yield call(deletePubBeer, action.payload);
    yield put(getPubBeersACS({pubId: action.payload.pubId, ...pubBeerFilters}));
  } catch (error) {
    yield call(handleError, error, 'Failed to delete pub beer');
  }
}
